module.exports = __webpack_public_path__ + "static/img/co4.1f45faf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cooperation/co4.jpg
// module id = 0E8D
// module chunks = 11